// LOP - PDP Style ID swatches: same JSON + sort order as PLP
(function () {
  'use strict';

  var shared = window.LOPStyleSwatchOrder;
  var enabled = window.theme && window.theme.settings && window.theme.settings.enable_related_by_style;

  if (!enabled || !shared) return;

  function buildPdpSwatchesHtml(items, currentHandle, swatchShape, swatchSize) {
    var html = '';

    items.forEach(function (item) {
      if (!item.swatchBg && !item.color) return;

      var isCurrent = item.handle === currentHandle;
      var colorLabel = shared.escapeHtml(item.color || item.title || '');
      var styleAttr = shared.escapeHtml(shared.buildSwatchStyle(item.swatchBg));
      var shapeAttrs =
        ' data-shape="' +
        shared.escapeHtml(swatchShape) +
        '" data-size="' +
        shared.escapeHtml(swatchSize) +
        '"';

      if (isCurrent) {
        html +=
          '<span class="product__color-swatch selected product-related-by-style__swatch product-related-by-style__swatch--active"' +
          shapeAttrs +
          ' style="' +
          styleAttr +
          '" aria-label="' +
          colorLabel +
          '" aria-current="true"></span>';
      } else {
        html +=
          '<button type="button" class="product__color-swatch product-related-by-style__swatch product-related-by-style__swatch--link" data-lop-pdp-style-swatch data-product-handle="' +
          shared.escapeHtml(item.handle) +
          '" data-product-url="' +
          shared.escapeHtml(item.url) +
          '"' +
          shapeAttrs +
          ' style="' +
          styleAttr +
          '" aria-label="' +
          colorLabel +
          '" title="' +
          colorLabel +
          '"></button>';
      }
    });

    return html;
  }

  function clearPdpSwatches(inner) {
    inner.querySelectorAll('.product-related-by-style__swatch').forEach(function (el) {
      el.remove();
    });
  }

  function mountPdpSwatches(inner, html) {
    var select = inner.querySelector('select');
    var mount = document.createElement('div');
    mount.innerHTML = html;

    while (mount.firstChild) {
      if (select) {
        inner.insertBefore(mount.firstChild, select);
      } else {
        inner.appendChild(mount.firstChild);
      }
    }
  }

  function initBlock(block) {
    if (!block || block.getAttribute('data-lop-pdp-swatches-built') === 'true') return;

    var inner = block.querySelector('.product__color-swatches--inner');
    var script = block.querySelector('script.lop-style-siblings-data');
    if (!inner || !script) return;

    var currentHandle = block.getAttribute('data-current-handle') || '';
    var swatchShape =
      block.getAttribute('data-swatch-shape') ||
      (window.theme && window.theme.settings && window.theme.settings.swatch_shape) ||
      'round';
    var swatchSize = block.getAttribute('data-swatch-size') || 'small';

    var siblings = shared.parseSiblingsFromScript(script);
    if (!siblings.length) return;

    var items = siblings
      .map(shared.normalizeSiblingItem)
      .filter(function (item) {
        return item;
      });

    items = shared.sortSiblings(items);
    clearPdpSwatches(inner);
    mountPdpSwatches(inner, buildPdpSwatchesHtml(items, currentHandle, swatchShape, swatchSize));
    block.setAttribute('data-lop-pdp-swatches-built', 'true');
  }

  function init(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll('[data-lop-pdp-style-switch]');

    blocks.forEach(function (block) {
      block.removeAttribute('data-lop-pdp-swatches-built');
      initBlock(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
